import uniqBy from 'lodash/uniqBy';
import { AssigneeModel } from '@/typings/models/Assignee';

const isDisabled = (agent: AssigneeModel) =>
  agent.active === false || agent.active === 0 || !!agent.disabled_at;

/**
 * Agents of one branch service ("direct colleagues" of a lead), current user first.
 * `null` when the service or its agents can't be resolved — callers then fall back
 * to the full user list instead of offering nobody.
 */
export function getBranchServiceColleagues(
  branch: any,
  branchServiceId: string | number | null | undefined,
  { hideDisabled = false, currentUserAlias }: { hideDisabled?: boolean; currentUserAlias?: string } = {},
): AssigneeModel[] | null {
  if (!branch?.services || branchServiceId == null) return null;
  const service = branch.services.find((s: any) => `${s.id}` === `${branchServiceId}`);
  const agents = uniqBy(
    ((service?.agents || []) as AssigneeModel[]).filter(
      (agent) => agent?.id && !(hideDisabled && isDisabled(agent)),
    ),
    (agent) => `${agent.id}`,
  );
  if (agents.length === 0) return null;
  const me = agents.find((agent) => agent.id === currentUserAlias);
  return me ? [me, ...agents.filter((agent) => agent !== me)] : agents;
}

export function filterAssigneesBySearch(assignees: AssigneeModel[], search?: string): AssigneeModel[] {
  const term = search?.trim().toLowerCase();
  if (!term) return assignees;
  return assignees.filter((agent) =>
    `${agent.firstname ?? ''} ${agent.lastname ?? ''} ${agent.email ?? ''} ${agent.personal_id ?? ''}`
      .toLowerCase()
      .includes(term),
  );
}
